export default "__VITE_ASSET__DGJ1gUoj__"